// extracted by mini-css-extract-plugin
module.exports = {"root":"Search_root__38aOv","input":"Search_input__1n3oV","button":"Search_button__gPScH"};